import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import ResourceService from '../../../services/resource.service';
import TopLeftHeader from './../topLeftHeader/topLeftHeader';
import TopRightHeader from './../topRightHeader/topRightHeader';

export default class HeaderTop extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stripePromise: null,
            stripeVal: null,
            email: localStorage.getItem("email"),
            isUserSubscribed: false
        };
        this.getStripeKey();
    }

    getStripeKey() {
        ResourceService.getStripeKey().then(data => {
            this.setState({
                stripePromise: loadStripe(data.toString()),
                stripeVal: true
            });
        }).catch(err => {
            console.log(err);
            return null;
        });
    }
    checkForSubscription = () => {
        this.setState({ showLoader: true });
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    showLoader: false,
                    message: "Error while getting user subscription details"
                });
                return;
            } else if(resp.error) {
                this.setState({
                    showLoader: false,
                    isUserSubscribed: false,
                });
            } else {
                this.setState({
                    showLoader: false,
                    isUserSubscribed: true,
                });
            }
        });
    };

    updateTopRightHeaderDetails() {
        this.setState({ email: localStorage.getItem("email") });
    }
    componentDidMount() {
        //this.checkForSubscription();
    }
    render() {
        return (
            <div className="header_wrap_top">
                <div className="top_navbar">
                    <TopLeftHeader showCreate={ this.props.showCreate } showBmr={ this.props.showBmr } ></TopLeftHeader>
                    {
                        this.state.stripeVal &&
                        <Elements stripe={ this.state.stripePromise }>
                            <ElementsConsumer>
                                { ({ stripe, elements }) => (
                                    <TopRightHeader stripe={ stripe } elements={ elements } regionCnt={ this.props.regionCnt } email={ this.state.email } isUserSubscribed={ this.props.isUserSubscribed } />
                                ) }
                            </ElementsConsumer>
                        </Elements>
                    }
                </div>
            </div >
        );
    }
}